import PropTypes from 'prop-types';
import {
    OBJECT_TYPE_GENERAL_ADMISSION,
    OBJECT_TYPE_SEAT,
} from '%paysera_seat_selection/js/seatSelection/config/constants';

export default ({
    price_type: PropTypes.shape({
        hash: PropTypes.string.isRequired,
    }).isRequired,
    ticket_type: PropTypes.shape({
        hash: PropTypes.string.isRequired,
    }).isRequired,
    tickets_count: PropTypes.number.isRequired,
    order_detail_id: PropTypes.number.isRequired,
    seating: PropTypes.shape({
        hash: PropTypes.string.isRequired,
        type: PropTypes.oneOf([OBJECT_TYPE_GENERAL_ADMISSION, OBJECT_TYPE_SEAT]),
    }),
});
